export default "__VITE_ASSET__B$W$lG0V__"